module.exports = __webpack_public_path__ + "img/icon7.6d3ad687.png";